module.exports = __webpack_public_path__ + "img/Close_L.7d498fbc.svg";